module.exports = __webpack_public_path__ + "img/carousel_2.1bddd3c5.png";